export default [{
  name: 'consiga',
  namespaced: true,
  state: {
    model: {
      selecionado: {},
      Pessoa: {
        PF: {},
        PessoaDadosContato: {},
        PessoaBanco: {},
        PessoaEndereco: {},
        PessoaQualificacao: {},
        PessoaReferencia: []
      },
      PropostaDadosVeiculo: {
        Placa: ''
      },
      Fornecedor: {
        Banco: {}
      },
    }
  },
  mutations: {
    model (state, obj) {
      state.model = obj
    }
  },
  getters: {
    model (state) {
      return state.model
    }
  },
  actions: {
    clearModel ({ commit }) {
      const data = {
        selecionado: {},
        Pessoa: {
          PF: {},
          PessoaDadosContato: {},
          PessoaDadoFinanceiro: {},
          PessoaEndereco: {},
          PessoaQualificacao: {},
          PessoaReferencia: []
        },
        PropostaDadosVeiculo: {
          Placa: ''
        },
        Fornecedor: {
          Banco: {}
        },
      }
      commit('model', data)
    }
  }
}]
